import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
    defaultPageSize: number = 50;
    isDarkMode: boolean = false; // テーマ状態
    userId: number | null = null;

    constructor(
        private authService: AuthService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit(): void {
        this.authService.fetchCurrentUser().subscribe(user => {
            if (user) {
                this.userId = user.id;
                this.defaultPageSize = user.default_page_size || 50;

                // DBの値を見て初期状態を設定
                this.isDarkMode = user.theme_mode === 'dark';
                this.applyTheme(this.isDarkMode);
            }
        });
    }

    // テーマ切り替え処理
    toggleTheme(): void {
        this.applyTheme(this.isDarkMode);
        this.saveSettings({ theme_mode: this.isDarkMode ? 'dark' : 'light' });
    }

    // クラスの着脱
    applyTheme(isDark: boolean): void {
        if (isDark) {
            document.body.classList.add('dark-theme');
        } else {
            document.body.classList.remove('dark-theme');
        }
    }

    // 表示件数保存
    savePageSize(): void {
        this.saveSettings({ default_page_size: this.defaultPageSize });
    }

    // 共通保存メソッド
    saveSettings(data: any): void {
        if (!this.userId) return;

        this.authService.updateUser(this.userId, data).subscribe({
            next: () => {
                this.snackBar.open('Saved', undefined, { duration: 1500 });
                this.authService.fetchCurrentUser().subscribe();
            },
            error: (err) => {
                console.error(err);
                this.snackBar.open('Failed to save', 'Close', { duration: 3000 });
            }
        });
    }
}